import { FC, ReactNode } from 'react';
import './Tooltip.scss';

interface IProps {
    text: string;
    nowrap?: boolean;
    className?: string;
    minWidth?: string;
    children?: ReactNode;
}

export const Tooltip: FC<IProps> = ({ children, text, nowrap, minWidth, className }) => {
    return (
        <div className="tooltip">
            {children}
            <div
                className={`tooltip__text tooltip--top ${className}`}
                style={{ whiteSpace: nowrap ? 'nowrap' : 'normal', minWidth: `${minWidth}%` }}
            >
                {text}
                <span className="tooltip__arrow"></span>
            </div>
        </div>
    );
};
